import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export default () => useMutation({
    mutationFn: ({ accountId, id }: { accountId: number; id: number }) => {
        const { api, baseURL } = getApi();
        return api.delete(`/api/v2/accounts/${accountId}/map-overlays/${id}`, { baseURL }).then(res => res.data.data);
    },
});
